import {Dispatch} from "redux";

import {getFavouriteObject} from "@pg-mono/favourites";

import {IRootState} from "../../store/store";
import {selectGetIsUserAuthenticated} from "../../user/utils/select_get_is_user_authenticated";
import {
    clearPendingFavouritesTopbar,
    consumePendingComparisonPropertyIds,
    consumePendingFavouriteOfferIds,
    consumePendingFavouritePropertyIds
} from "../utils/pending_favourites_auth";
import {removeFromComparison, removeFromFavourites} from "./manage_favourites";

export const discardAbandonedGuestFavourites = () => async (dispatch: Dispatch, getState: () => IRootState) => {
    if (selectGetIsUserAuthenticated(getState())) {
        return;
    }

    const propertyIds = consumePendingFavouritePropertyIds();
    const offerIds = consumePendingFavouriteOfferIds();
    const comparisonIds = consumePendingComparisonPropertyIds();
    const {list} = getState().favourite.favourites;

    clearPendingFavouritesTopbar();

    for (const propertyId of propertyIds) {
        await removeFromFavourites([getFavouriteObject({propertyId})])(dispatch, getState);
    }

    for (const offerId of offerIds) {
        await removeFromFavourites([getFavouriteObject({offerId})])(dispatch, getState);
    }

    for (const propertyId of comparisonIds) {
        if (propertyIds.includes(propertyId)) {
            continue;
        }

        const existingFavourite = list.find((favourite) => favourite.property?.rp_id === propertyId && favourite.in_comparison);

        if (!existingFavourite) {
            continue;
        }

        await removeFromComparison({...existingFavourite, in_comparison: false}, false)(dispatch, getState);
    }
};
import {Dispatch} from "redux";

import {getFavouriteObject} from "@pg-mono/favourites";

import {IRootState} from "../../store/store";
import {selectGetIsUserAuthenticated} from "../../user/utils/select_get_is_user_authenticated";
import {
    clearPendingFavouritesTopbar,
    consumePendingComparisonPropertyIds,
    consumePendingFavouriteOfferIds,
    consumePendingFavouritePropertyIds
} from "../utils/pending_favourites_auth";
import {removeFromComparison, removeFromFavourites} from "./manage_favourites";

export const discardAbandonedGuestFavourites = () => async (dispatch: Dispatch, getState: () => IRootState) => {
    if (selectGetIsUserAuthenticated(getState())) {
        return;
    }

    const propertyIds = consumePendingFavouritePropertyIds();
    const offerIds = consumePendingFavouriteOfferIds();
    const comparisonIds = consumePendingComparisonPropertyIds();
    const {list} = getState().favourite.favourites;

    clearPendingFavouritesTopbar();

    for (const propertyId of propertyIds) {
        await removeFromFavourites([getFavouriteObject({propertyId})])(dispatch, getState);
    }

    for (const offerId of offerIds) {
        await removeFromFavourites([getFavouriteObject({offerId})])(dispatch, getState);
    }

    for (const propertyId of comparisonIds) {
        if (propertyIds.includes(propertyId)) {
            continue;
        }

        const existingFavourite = list.find((favourite) => favourite.property?.rp_id === propertyId && favourite.in_comparison);

        if (!existingFavourite) {
            continue;
        }

        await removeFromComparison({...existingFavourite, in_comparison: false}, false)(dispatch, getState);
    }
};
